import storage from '@/utils/storage.js'
import config from '@/config'
const state={
    scrollState:0,                  //滚动状态0首页头部透明，1其它
    username:'',                    //用户名
    navIndex:0,                     //首页导航状态
    courseData:[],                  //全部课程数据
    userInfo:{staff:{}},            //用户信息
    breadcrumb:[],                  //面包屑
    homeKeep:{},                    //app.vue缓存
};
const getters={};
const actions={};
const mutations={
    setScrollState(state,v){
        state.scrollState=v;
    },
    setUsername(state,v){
        state.username=v;
    },
    setNavIndex(state,v){
        state.navIndex=v;
    },
    setCourseData(state,v){
        state.courseData=v;
    },
    getStaffInfo(state,v){
        state.userInfo=v;
    },
    setBreadcrumb(state,v){     //设置面包屑
        if (typeof(v) === 'object' && v.query.title) { // 修改浏览器标题
            try {
                document.title = `LMS ${config.bottomNumber} | ${v.query.title}`
            } catch (error) {
                document.title = 'LMS'
            }
        } else {
            try {
                document.title = `LMS ${config.bottomNumber || ''}`
            } catch (error) {}
        }

        if(storage.sessionGet('breadcrumb')===null){
            storage.sessionSet('breadcrumb',[])
        }
        const t2=['/home/message']; //第二梯队
        const breadcrumb=storage.sessionGet('breadcrumb');
        if(v === ''){   //首页重置
            storage.sessionSet('breadcrumb',[]);
            state.breadcrumb = [];
            return;
        }
        
        const rank=t2.findIndex(item=>item == v.path);
        if(breadcrumb.length === 0){
            storage.sessionSet('breadcrumb',[...breadcrumb,v])
        }else {
            if(rank>=0){
                storage.sessionSet('breadcrumb',[v])
                state.breadcrumb = [v];
                return;
            }
            const pathData=breadcrumb.findIndex(item=>item.path === v.path);
            if(pathData == -1){     //页面是否已存在
                storage.sessionSet('breadcrumb',[...breadcrumb,v])
            }else{
                const breadLength=breadcrumb.length;
                let bread=storage.sessionGet('breadcrumb');
                    bread.splice(pathData,1,{...v});    //已经存在替换
                    storage.sessionSet('breadcrumb',bread)
                if(pathData<=breadLength){
                    let breadSlice=bread.slice(0,pathData+1); //分割返回上一级
                    storage.sessionSet('breadcrumb',breadSlice)
                }
            }
        }
        state.breadcrumb = storage.sessionGet('breadcrumb');
    },
    setFirstBreadcrumb(state,v){  //设置第一个面包屑数据
        const breadcrumb=storage.sessionGet('breadcrumb');
        const breadSlice=breadcrumb.slice(breadcrumb.length-v,breadcrumb.length); //分割返回上一级
        storage.sessionSet('breadcrumb',breadSlice);
        state.breadcrumb = breadSlice;
    },
    setHomeKeep(state,v){//缓存首页数据
        state.homeKeep={...state.homeKeep,...v};
    },
    emptyHomeKeep(state,v){ //清空首页数据
        state.homeKeep=[];
        state.courseData=[];
        state.courseData={staff:{}};
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}
